<template>
  <div>
    <v-container fluid fill-height>
      <v-card-text class=" text-xs-center text-md-center text-lg-center">
        <div class="headline font-weight-bold">
          <span v-if="loading" class="primary--text">{{ $t("screener.access_link.loader.message")}}</span>
          <div v-else-if="error_message">
            <span class="error--text">Error::</span><span>{{error_message}}</span>
          </div>
        </div>
      </v-card-text>
    </v-container>
    <MagicLinkUserForm
      ref="magicLink"
      v-if="dialog"
      :dialog="dialog"
      :user.sync="user"
      @login="loginWithMagicLink"
      @reset="reset">
    </MagicLinkUserForm>
  </div>
</template>

<script>
import MagicLinkUserForm from "@/components/dialogBox/MagicLinkUserForm"

const ACCESS_LINK_MODES = {
  simulation:"PREVIEW_LINK", // Preview link for a movie
  anonymous:"MAGIC_LINK",   // Admin generated link for participation
  consumer:"LOGIN_LINK",   // Login link in participation/remainder mail
}

export default {
  name: "AccessLink",
  async beforeRouteEnter(to, from, next) {
    await next(vm => {
      if(vm.$route.query && vm.$route.query.mode){
        vm.handleLoginWithLink(vm.$route.query.mode);
      }
      else{
        vm.askUserDetails();
      }
    });
  },
  data() {
    return {
      loading: false,
      error_message: null,
      dialog:false,
      user:null
    };
  },
  components:{
    MagicLinkUserForm
  },
  methods: {
    handleLoginWithLink(mode){
      if(ACCESS_LINK_MODES.hasOwnProperty(mode)){
          var link_id = this.$route.params.link_id;
          switch (ACCESS_LINK_MODES[mode]) {
            case ACCESS_LINK_MODES.simulation:
              this.doLoginWithLink({link_id});
              break;
            case ACCESS_LINK_MODES.anonymous:
              this.askUserDetails();
              break;
            case ACCESS_LINK_MODES.consumer:
              this.doLoginWithLink({link_id});
              break;
            default:
              this.askUserDetails();
              break;
          }
      }
    },
    askUserDetails(){
      this.dialog = true;
    },
    reset(){
      this.dialog = false;
      this.user = null;
    },
    async loginWithMagicLink() {
      if (!this.$refs.magicLink.validate()) {
        return false;
      }
      this.loading = true;
      var payload = {
        link_id: this.$route.params.link_id,
        name:this.user.name,
        email:this.user.email
      }
      this.reset();
      await this.doLoginWithLink(payload);
    },
    async doLoginWithLink(payload){
      try {
          await this.$store.dispatch("auth/loginWithAccessLink", payload);
          this.goToWatchPage();
      } catch (error) {
          this.error_message = error.message;
      }finally{
          this.loading = false;
      }
    },
    async goToWatchPage() {
      this.$router.push({
        name: "screeners.watch",
        params: {
          screener_id: this.$route.params.screener_id
        },
        query:this.$route.query
      });
    }
  }
};
</script>
